import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// @material-ui/icons

// core components
import GridItem from '../../../components/Grid/GridItem.js';
import Button from '../../../components/CustomButtons/Button.js';
import Card from '../../../components/Card/Card.js';
import CardBody from '../../../components/Card/CardBody.js';
import CardFooter from '../../../components/Card/CardFooter.js';

import styles from '../../../assets/jss/material-kit-react/views/landingPageSections/teamStyle.js';

import massi from '../../../assets/img/faces/massi.JPG';

const useStyles = makeStyles(styles);

export default function TeamSection() {
  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <h2 className={classes.title}>Who are we?</h2>
      <div
        style={{
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Card plain>
          <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
            <img
              src={massi}
              alt='developer of the application, Massi Faqiri'
              className={imageClasses}
              width='300'
            />
          </GridItem>
          <h3 className={classes.cardTitle}>
            Massi Faqiri
            <br />
            <small className={classes.smallTitle}>Developer</small>
          </h3>
          <CardBody>
            <p className={classes.description}>
              I am a recent graduate software developer who loves developing web
              and native applications. <br />I get excited about learning and
              utilizing new technologies to grow as a developer. <br /> Proud
              GitHub Arctic Code Vault Contributor! Also, actively seeking
              full-time or part-time positions! <br />
              My personal email: massi.faqiri12@gmail.com
            </p>
          </CardBody>
          <CardFooter className={classes.justifyCenter}>
            <Button
              justIcon
              color='transparent'
              className={classes.margin5}
              href='https://www.massifaqiri.com/'
              target='_blank'
            >
              <i className={classes.socials + ' fas fa-user'} />
            </Button>
            <Button
              justIcon
              color='transparent'
              className={classes.margin5}
              href='https://www.linkedin.com/in/massifaqiri/'
              target='_blank'
            >
              <i className={classes.socials + ' fab fa-linkedin'} />
            </Button>
            <Button
              justIcon
              color='transparent'
              className={classes.margin5}
              href='https://github.com/faqima01/'
              target='_blank'
            >
              <i className={classes.socials + ' fab fa-github'} />
            </Button>
            <Button
              justIcon
              color='transparent'
              className={classes.margin5}
              href='https://medium.com/@massifaqiri'
              target='_blank'
            >
              <i className={classes.socials + ' fab fa-medium'} />
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
